import { render } from "./ResetPasswordV2.vue?vue&type=template&id=319bfd85&scoped=true"
import script from "./ResetPasswordV2.vue?vue&type=script&lang=js"
export * from "./ResetPasswordV2.vue?vue&type=script&lang=js"

import "./ResetPasswordV2.vue?vue&type=style&index=0&id=319bfd85&scoped=true&lang=scss"
import "./ResetPasswordV2.vue?vue&type=style&index=1&id=319bfd85&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-319bfd85"]])

export default __exports__